import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./HistoryPage.css";
import Loader from "../../components/Loader";

const HistoryPage = () => {
  //fetch dat
  const { loading, error, data } = useFetch(
    `${config.api}/api/history-page?populate=background`
  );

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání historie" />;

  if (!data || !data.data) return <DefaultPage message="Žádná historie" />;

  //? test
  //? console.log(data.data);

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div>
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-5">
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default HistoryPage;
